<div class="masonry-item__container"
     [style.margin]="0+' '+'-'+gutter"
>
  <div class="masonry-item__column"
       *ngFor="let column of dataColumnFormatted"
       [style.padding]="0+' '+gutter"
  >
    <div
      class="masonry-item"
      *ngFor="let item of column"
      [style.padding]="gutter+' '+0"
    >
      <ng-container
        *ngIf="masonryItem"
        [ngTemplateOutlet]="masonryItem"
        [ngTemplateOutletContext]="{$implicit:item}"
      ></ng-container>
    </div>
  </div>
</div>
